// Featured guides whose places took their photo/notes from the wrong Wikipedia
// article (Florence "David" → King David). The fixes come from a file built
// offline from the user's review (Featured Videos/wiki-source-fixes-*.json):
//   { fixes: [{ guide_info_id, guide, place_id, place, action, expect: { Hlink }, set: {...} }] }
// action: "article" (new Hlink/Info/Photo/Photo_m, maybe Name), "clear" (wrong
// link and notes dropped, Google photo) or "pin" (Lat/Longi moved to the
// article's location). A fix is applied only while the place still has the
// Hlink it was reviewed with, so later edits in the app are never overwritten.
// Used by Admin Dashboard → Guides (FeaturedWikiFixPanel). 2026-10-27.

const placeOf = (data, id) => (data?.places?.placesList || []).find((p) => String(p.ID) === String(id));

// guides: getFeaturedGuidesData's list. Returns one row per fix:
// { fix, guide, status: "ready" | "done" | "changed" | "missing" }
export function planWikiFixes(guides, fixes) {
  const byInfo = new Map((guides || []).map((g) => [g.guide_info_id, g]));
  return (fixes || []).map((fix) => {
    const guide = byInfo.get(fix.guide_info_id);
    const place = guide && placeOf(guide.data, fix.place_id);
    if (!place) return { fix, guide, status: "missing" };
    const already = Object.entries(fix.set || {}).every(([k, v]) => place[k] === v);
    if (already) return { fix, guide, status: "done" };
    if ((place.Hlink || "") !== (fix.expect?.Hlink || "")) return { fix, guide, status: "changed" };
    return { fix, guide, status: "ready" };
  });
}

// Returns a copy of the guide's data with the fixes applied. A renamed place
// also renames its schedule events that carry the old name.
export function applyWikiFixes(data, fixes) {
  const byId = new Map((fixes || []).map((f) => [String(f.place_id), f]));
  const renamed = new Map();
  const placesList = (data.places?.placesList || []).map((p) => {
    const fix = byId.get(String(p.ID));
    if (!fix) return p;
    if (fix.set.Name && fix.set.Name !== p.Name) renamed.set(String(p.ID), { from: p.Name, to: fix.set.Name });
    return { ...p, ...fix.set };
  });
  const events = (data.schedule?.events || []).map((e) => {
    const ids = String(e.Places || "").split(",");
    const r = ids.map((id) => renamed.get(id.trim())).find((x) => x && x.from === e.Subject);
    return r ? { ...e, Subject: r.to } : e;
  });
  return {
    ...data,
    places: { ...data.places, placesList },
    ...(data.schedule ? { schedule: { ...data.schedule, events } } : {}),
  };
}
